import { StackedGroupBarChart } from "@jana-technology/platform-ui";

import { useGlobalFiltersContext } from "contexts/filters";
import { useTotalSystemOverviewCharts } from "hooks/queries";
import { xAccessor } from "helpers/charts";

import { ChartCard } from "components/charts/ChartCard";
import { TopRiskWellsByThreatOperational } from "components/charts/TopRiskWellsOperational";
import {
  BASE_BAR_CHART_PROPS,
  LG_BAR_CHART_SIZE,
  MD_BAR_CHART_SIZE,
} from "constants/charts";

export const SystemOverviewOperationalCharts = () => {
  const { hierarchyIds } = useGlobalFiltersContext();

  const totalSystemOverviewCharts = useTotalSystemOverviewCharts({
    variables: { hierarchyIds },
  });

  const chartSize =
    window.innerWidth <= 1600 ? MD_BAR_CHART_SIZE : LG_BAR_CHART_SIZE;
  const barChartProps = {
    ...BASE_BAR_CHART_PROPS,
    ...chartSize,
  };

  return (
    <div className="mb-4 flex flex-col gap-10">
      <ChartCard
        loading={totalSystemOverviewCharts.loading}
        heading="Risk by Threat"
      >
        <StackedGroupBarChart
          withBarLabels
          {...barChartProps}
          chartName="Risk by Threat"
          xAccessor={xAccessor}
          data={totalSystemOverviewCharts.threatORTab}
          dataKeys={totalSystemOverviewCharts.threatORDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={totalSystemOverviewCharts.loading}
        heading="Risk by Consequence"
      >
        <StackedGroupBarChart
          withBarLabels
          {...barChartProps}
          chartName="Risk by Consequence"
          xAccessor={xAccessor}
          data={totalSystemOverviewCharts.consequenceORTab}
          dataKeys={totalSystemOverviewCharts.consequenceORDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={totalSystemOverviewCharts.loading}
        heading="Risk by Outcome Scenario"
      >
        <StackedGroupBarChart
          withBarLabels
          {...barChartProps}
          chartName="Risk by Outcome Scenario"
          xAccessor={xAccessor}
          data={totalSystemOverviewCharts.outcomeORTab}
          dataKeys={totalSystemOverviewCharts.outcomeORDataKeys}
        />
      </ChartCard>
      <TopRiskWellsByThreatOperational />
    </div>
  );
};

export default SystemOverviewOperationalCharts;
